import * as actionTypes from '../actions/actionTypes'

const initialState = {
  pagination: { total: 0, to: 0, lastPage: 1, from: 0, currentPage: 1, perPage: 10 },
  records: [],
  loading: false,
  filterLoading: false,
  success: false,
  selectedRecord: null,
  company: [],
  positionGroup: [],
  filterCompany: [],
  filterKpiType: [],
  loadingStates: []
}

const fetchKpiTypeStart = (state, action) => {
  return { ...state, loading: true, loadingStates: [...state.loadingStates, 'record'] }
}

const fetchKpiTypeSuccess = (state, action) => {
  let { records } = action
  records = records.map(res => {
    let data = res
    return {
      ...data,
      company_code: data?.company?.company_code
    }
  })
  return {
    ...state,
    loading: false,
    loadingStates: state.loadingStates.filter(item => item !== 'record'),
    pagination: action.pagination,
    records
  }
}

const fetchKpiTypeFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    loadingStates: state.loadingStates.filter(item => item !== 'record'),
    errorMessage: action.errorMessage
  }
}

const fetchKpiTypeByIdSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    selectedRecord: action.recordData,
    loadingStates: state.loadingStates.filter(item => item !== 'record')
  }
}

const clearSelectedKpiTypeRecord = (state, action) => {
  return {
    ...state,
    selectedRecord: { is_active: true },
    success: false
  }
}

const createKpiTypeStart = (state, action) => {
  return { ...state, loading: true }
}

const createKpiTypeSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const createKpiTypeFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const updateKpiTypeStart = (state, action) => {
  return { ...state, loading: true }
}

const updateKpiTypeSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const updateKpiTypeFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const deleteKpiTypeStart = (state, action) => {
  return { ...state, loading: true }
}

const deleteKpiTypeSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const deleteKpiTypeFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const fetchCompanyStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchCompanySuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    company: action.data
  }
}

const fetchCompanyFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage
  }
}

const fetchFilterKpiTypeStart = (state, action) => {
  return { ...state, filterLoading: true }
}

const fetchFilterKpiTypeSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    filterKpiType: action.data
  }
}

const fetchFilterKpiTypeFailed = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    message: action.errorMessage
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_KPI_TYPE_START:
      return fetchKpiTypeStart(state, action)
    case actionTypes.FETCH_KPI_TYPE_SUCCESS:
      return fetchKpiTypeSuccess(state, action)
    case actionTypes.FETCH_KPI_TYPE_BY_ID_SUCCESS:
      return fetchKpiTypeByIdSuccess(state, action)
    case actionTypes.FETCH_KPI_TYPE_FAILED:
      return fetchKpiTypeFailed(state, action)
    case actionTypes.CLEAR_SELECTED_KPI_TYPE_RECORD:
      return clearSelectedKpiTypeRecord(state, action)
    case actionTypes.CREATE_KPI_TYPE_START:
      return createKpiTypeStart(state, action)
    case actionTypes.CREATE_KPI_TYPE_SUCCESS:
      return createKpiTypeSuccess(state, action)
    case actionTypes.CREATE_KPI_TYPE_FAILED:
      return createKpiTypeFailed(state, action)
    case actionTypes.UPDATE_KPI_TYPE_START:
      return updateKpiTypeStart(state, action)
    case actionTypes.UPDATE_KPI_TYPE_SUCCESS:
      return updateKpiTypeSuccess(state, action)
    case actionTypes.UPDATE_KPI_TYPE_FAILED:
      return updateKpiTypeFailed(state, action)
    case actionTypes.DELETE_KPI_TYPE_START:
      return deleteKpiTypeStart(state, action)
    case actionTypes.DELETE_KPI_TYPE_SUCCESS:
      return deleteKpiTypeSuccess(state, action)
    case actionTypes.DELETE_KPI_TYPE_FAILED:
      return deleteKpiTypeFailed(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_START:
      return fetchCompanyStart(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_SUCCESS:
      return fetchCompanySuccess(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_FAILED:
      return fetchCompanyFailed(state, action)
    case actionTypes.FETCH_KPI_TYPE_OPTIONS_START:
      return fetchFilterKpiTypeStart(state, action)
    case actionTypes.FETCH_KPI_TYPE_OPTIONS_SUCCESS:
      return fetchFilterKpiTypeSuccess(state, action)
    case actionTypes.FETCH_KPI_TYPE_OPTIONS_FAILED:
      return fetchFilterKpiTypeFailed(state, action)
    case actionTypes.SIGNOUT_SUCCESS:
    case actionTypes.SIGNOUT_FAILED:
      return { ...initialState }
    default:
      return state
  }
}

export default reducer
